import { DateTime } from 'luxon';

export const MONTH_DAY_FORMAT = 'LLL d';
export const DATE_FORMAT = 'M/d/yy';
export const TIME_FORMAT = 'h:mm a';
export const FULL_DATE_FORMAT = 'MM/dd/yyyy';
export const FULL_DATETIME_FORMAT = `${FULL_DATE_FORMAT} hh:mm a`;

export const isThisYear = (timestamp) => {
  const date = new Date(timestamp);
  const today = new Date();

  return date.getFullYear() === today.getFullYear();
};

export const isToday = (timestamp) => {
  const date = new Date(timestamp);
  const today = new Date();

  return date.toDateString() === today.toDateString();
};

export const timestampInTimezone = (iso8601Timestamp, ianaTimezone, format = 'LLL d h:mm a') => {
  if (!iso8601Timestamp) return '';

  const options = {};
  if (ianaTimezone) options.zone = ianaTimezone;

  const date = DateTime.fromISO(iso8601Timestamp, options);

  return date.toFormat(format);
};

export const dateStamp = (iso8601Timestamp) => timestampInTimezone(iso8601Timestamp, null, DATE_FORMAT);

// this function determines if a timestamp is today or not,
// if it is today, it returns a short timestamp (hh:mm)
// if it is not today, it returns a full timestamp (MM/dd/yy)
// being used in ChatListItem (so far)
export const formatTimestamp = (timestampString) => {
  const now = new Date();
  const timestamp = new Date(timestampString);

  if (now.getDate() === timestamp.getDate()) {
    return timestamp.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
  }

  return timestamp.toLocaleDateString([], { year: '2-digit', month: 'numeric', day: '2-digit' });
};
